/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'binary_circle': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75.5 128C46.505 128 23 104.495 23 75.5S46.505 23 75.5 23 128 46.505 128 75.5 104.495 128 75.5 128zm-26.498-21.002L49 107h54V57.501L89.501 44H49.002v62.998zM100 59.765L99.948 104H53V48l35.164.052L100 59.765zM80.754 81.547v-12h-10v12h10zm-3-9v6h-3v-6h3zm-.087-8.798V54H71v3.25h3.333v6.5H71V67h10v-3.25h-3.333zM64.999 79V70H59v3h2.998v6H59v3h9v-3h-3.001zm2.755-12.452v-13h-9v13h9zm-3-9v6h-3v-6h3zm25.245 21.455v-8.999L84 70v3h2.998v6.002H84V82h9v-2.998h-3.001zm2.755-12.455v-13h-9v13h9zm-3-10v7h-3v-7h3zM77.667 94.749V85H71v3.25h3.333v6.5H71V98h10v-3.25h-3.333zm-9.913 2.798v-13h-9v13h9zm-3-9v6h-3v-6h3zm28 9v-13h-9v13h9zm-3-9v6h-3v-6h3z" _fill="#C4FFF9" fill-rule="evenodd"/>'
  }
})
